var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-left margin-halfem"},[_vm._v("絞り込む")]),_vm._v(" "),_c('div',{staticClass:"srv-tags"},_vm._l((_vm.tags),function(tag){return _c('button',{class:{ 'is-active': tag.value === (_vm.activeTag ? _vm.activeTag : '') },on:{"click":function($event){_vm.handleUpdate(tag.value)}}},[_vm._v("\n      "+_vm._s(tag.label)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef4d49a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tags.vue
// module id = null
// module chunks = 